import { FC, PropsWithChildren } from "react";

export function combineComponents(
  ...Components: FC<PropsWithChildren>[]
): FC<PropsWithChildren> {
  return ({ children }) =>
    Components.reduceRight(
      (acc, Component) => <Component>{acc}</Component>,
      <>{children}</>,
    );
}
